@if (filterType && showHeader) {
  <div class="filters-inline-edit-lozenges-header">
    <div class="filters-inline-edit-lozenges-header-title">
      {{ label ? label : (filterType | localiseFilterType) }}
    </div>

    @if (!disabled) {
      <i class="material-symbols-outlined" (click)="onClose()">close</i>
    }
  </div>
}
@if (enrichedFilters?.length > 0) {
  <div class="filters-inline-edit-lozenges-body">
    @for (filter of enrichedFilters; track filter.id ?? filter.filterValue ?? $index) {
    @if (filter.filterText) {
        <app-chip
          [canRemove]="canRemove"
          [disabled]="disabled"
          [tooltip]="{ message: filter.filterText }"
          [class.primary-chip]="isPrimaryFunctionalityAllowed"
          (lozengeClicked)="onFilterRemove(filter)"
        >
          @if (filterType === filterTypes.Owner) {
            <app-employee-avatar
              class="mr-8"
              [size]="2"
              [employee]="getEmployee(filter.filterValue)"
            />
          }

          {{ filter.filterText }}

          @if (isPrimaryFunctionalityAllowed) {
            <div class="primary-wrapper">
              <i
                class="material-symbols-outlined star-symbol"
                [class.primary]="filter.isPrimary"
                (mouseover)="isPrimaryIconHovered = true"
                (mouseout)="isPrimaryIconHovered = false"
                (click)="$event.stopPropagation(); onPrimaryClick(filter)"
              >star</i>
            </div>
          }
        </app-chip>
      }
    }
  </div>
} @else {
  <div class="filters-inline-edit-lozenges-text">
    {{ T.common.no_items_selected | translate }}
  </div>
}
